import script from "./page-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./page-modal.vue?vue&type=script&setup=true&lang=js"

import "./page-modal.vue?vue&type=style&index=0&id=009b2bd2&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-009b2bd2"]])

export default __exports__